import api from "@/api";
import * as Cookie from "js-cookie";
import { JSConn } from "@/utilities/js-conn";

interface SessionState {
  companyName: string;
  isLoggedIn: boolean;
  userEmail: string | null;
  userName: string | null;
  userPermissionLevel: string;
  nextPath: string;
}

const state: SessionState = {
  companyName: "The Hay Broker App",
  isLoggedIn: false,
  userEmail: null,
  userName: null,
  userPermissionLevel: "field_worker",
  nextPath: "/work-queue",
};

const mutations = {
  SET_NEXT_PATH(state: SessionState, payload: string) {
    state.nextPath = payload;
  },
  SET_LOGGED_IN(state: SessionState, payload: boolean) {
    state.isLoggedIn = payload;
  },
  SET_COMPANY_NAME(state: SessionState, payload: string) {
    state.companyName = payload;
  },
  SET_USER_NAME(state: SessionState, payload: string) {
    state.userName = payload;
  },
  SET_USER_EMAIL(state: SessionState, payload: string) {
    state.userEmail = payload;
  },
  SET_USER_PERMISSION_LEVEL(state: SessionState, payload: string) {
    state.userPermissionLevel = payload;
  },
};

const actions = {
  updateNextPath(context: any, nextPath: string) {
    context.commit("SET_NEXT_PATH", nextPath);
  },
  loadSessionData(context: any, jsConn: JSConn) {
    return new Promise(resolve => {
      context.commit("SET_LOGGED_IN", true);
      context.commit("SET_COMPANY_NAME", jsConn.response["company_name"]);
      context.commit("SET_USER_NAME", jsConn.response["user_name"]);
      context.commit("SET_USER_EMAIL", jsConn.response["user_email"]);
      context.commit(
        "SET_USER_PERMISSION_LEVEL",
        jsConn.response["permission_level"],
      );
      localStorage.setItem("token", jsConn.response["token"]);
      Cookie.set("user_token", jsConn.response["token"], { expires: 30 });
      resolve(jsConn);
    });
  },
  logInUser(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.logInUser(jsConn).then(jsConn => {
      context.commit("SET_LOGGED_IN", true);
      context.commit("SET_COMPANY_NAME", jsConn.response["company_name"]);
      context.commit("SET_USER_NAME", jsConn.response["user_name"]);
      context.commit("SET_USER_EMAIL", jsConn.response["user_email"]);
      context.commit(
        "SET_USER_PERMISSION_LEVEL",
        jsConn.response["permission_level"],
      );
      localStorage.setItem("token", jsConn.response["token"]);
      Cookie.set("user_token", jsConn.response["token"], { expires: 30 });
      return Promise.resolve(jsConn);
    });
  },
  logOutUser(context: any, jsConn: JSConn) {
    context.commit("SET_LOGGED_IN", false);
    context.commit("SET_COMPANY_NAME", "The Hay Broker App");
    context.commit("SET_USER_NAME", null);
    context.commit("SET_USER_EMAIL", null);
    context.commit("SET_USER_PERMISSION_LEVEL", "field_worker");
    localStorage.setItem("token", "");
    Cookie.set("user_token", "");
    return Promise.resolve(jsConn);
  },
};

const getters = {
  companyName: (state: SessionState) => state.companyName,

  userName: (state: SessionState) => state.userName,

  isLoggedIn: (state: SessionState) => state.isLoggedIn,

  nextPath: (state: SessionState) => state.nextPath,

  userPermissionLevel: (state: SessionState) => state.userPermissionLevel,

  isAdmin: (state: SessionState) => {
    return state.userPermissionLevel === "admin";
  },

  isFieldWorker: (state: SessionState) => {
    return state.userPermissionLevel === "field_worker";
  },
};

const sessionModule = {
  state,
  mutations,
  actions,
  getters,
};

export default sessionModule;
